import { render, staticRenderFns } from "./summary-info.html?vue&type=template&id=4df58f44&scoped=true&external"
import script from "./summary-info.js?vue&type=script&lang=js&external"
export * from "./summary-info.js?vue&type=script&lang=js&external"
import style0 from "./summary-info.scss?vue&type=style&index=0&id=4df58f44&prod&lang=scss&scoped=true&external"
import style1 from "../swiperBundle/swiper-bundle.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df58f44",
  null
  
)

export default component.exports